import styled from 'styled-components';
import { LinkContained } from './form/LinkContained';
import { PreloadedImage } from './PreloadedImage'
import { useQuery } from '@apollo/client';
import { GET_ILLUSTRATED_CTA } from '../graphql/queries';

interface Props extends React.HTMLProps<HTMLDivElement> {
	ctaId: string;
	imageId: string;
	locale: string;
}

const Container = styled.div`
	display: grid;
	grid-gap: 48px;
	align-items: center;
	grid-template-columns: repeat(2, 1fr);
`;

const Body = styled.div`
	${({ theme }) => theme.typography.richtext};
	${({ theme }) => theme.typography.heading4};
	margin-bottom: 8px;
`;

const Image = styled(PreloadedImage)`
	display: block;
	width: 100%;
`;

export const IllustratedCTA = ({ ctaId, imageId, className, locale }: Props) => {
	const { data, loading } = useQuery(GET_ILLUSTRATED_CTA, { variables: { ctaId, imageId, locale } });

	return loading
		? <div>loading</div>
		: <Container className={className}>
			<div>
				<Body dangerouslySetInnerHTML={{ __html: data.cta.bodyHTML }} />
				<LinkContained href={data.cta.link}>{data.cta.label}</LinkContained>
			</div>
			<Image {...data.preloadedImage} />
		</Container>
};